module.exports = __webpack_public_path__ + "img/img0103.8077926e.png";